import Accordion, { Row } from "@storeblocks/accordion";
import { useTexts } from "Components/TextContext";
import React from "react";

export const CheckPriceSurveyAccordion = (): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <Accordion borderTop={false}>
      <Row
        id="ssx-check-price-survey-row"
        header={getText("checkprice.common.checkpricesurvey")}
        headerProps={{ type: "button" }}
      >
        <div
          id="ssx-check-price-survey"
          className="hotjar-survey-border hotjar-survey-no-shadow"
        ></div>
      </Row>
    </Accordion>
  );
};
